export enum TypeOfAppointmentEnum {
    Presencial = 'P',
    Teleatendimento = 'T'
}